import { ReactNode } from "react";

import { useAppHistory } from "@/common/hooks/routing/useAppHistory";

import AppIcon from "../Icons/AppIcon";
import AppLink from "./AppLink";

interface Props {
  icon?: ReactNode;
  title?: string;
  to?: string;
  children?: ReactNode;
}

export default function GoBackLink({ icon, title, to, children }: Props) {
  const history = useAppHistory();
  return (
    <AppLink
      to={to || "#"}
      onClick={(e) => {
        if (!to) {
          e.preventDefault();
          history.goBack();
        }
      }}
    >
      {!children && (
        <>
          {icon || <AppIcon of='goBack' />} {title || "Go back"}
        </>
      )}
      {children && children}
    </AppLink>
  );
}
